// extracted by mini-css-extract-plugin
export default {"icon":"businessAccounts_icon__TcEf6","iconDanger":"businessAccounts_iconDanger__e2QHa"};